import { CookieTableHeadType } from '~/static-pages/Cookies/types/Cookies.types'

const sharedTableClassName = 'text-left p-3 text-xs w-auto'

export const CookieTableHead = ({ tableTitles }: CookieTableHeadType): React.ReactElement => {
  return (
    <thead>
      <tr className="flex flex-col flex-no wrap mb-2 sm:mb-0">
        {tableTitles.map((tableTitle) => {
          if (tableTitle === 'Formål' || tableTitle === 'Lagringstid') {
            return (
              <th className={`${sharedTableClassName} h-20 sm:h-16 md:h-14`} key={tableTitle}>
                {tableTitle}
              </th>
            )
          } else {
            return (
              <th className={`${sharedTableClassName} h-10`} key={tableTitle}>
                {tableTitle}
              </th>
            )
          }
        })}
      </tr>
    </thead>
  )
}
